import {
  unwrapFieldValue,
  wrapFieldValue,
} from 'features/libra/ontology/ontologyFieldDefaults'
import { EditableNotes } from 'features/libra/stepComponents/niiReport/NiiFieldComponents'
import { useNiiReportData } from 'features/libra/stepComponents/niiReport/NiiReportDataContext'
import { FC, memo, useCallback } from 'react'

import { StyledCard } from './cardsStyles'

export interface NiiReportInfoCardProps {
  readonly title: string
  readonly fieldKey: string
  readonly readonly?: boolean
}

const RawNiiReportInfoCard: FC<NiiReportInfoCardProps> = ({
  title,
  fieldKey,
  readonly,
}) => {
  const { localValues, setLocalFieldValue } = useNiiReportData()

  const value = unwrapFieldValue<string>(localValues[fieldKey])

  const handleChange = useCallback(
    (newValue: string | undefined) => {
      setLocalFieldValue(fieldKey, wrapFieldValue(newValue))
    },
    [setLocalFieldValue, fieldKey]
  )

  return (
    <StyledCard title={title}>
      <EditableNotes
        value={value}
        onChange={readonly ? undefined : handleChange}
      />
    </StyledCard>
  )
}

export const NiiReportInfoCard = memo(RawNiiReportInfoCard)
